
import RADAR_MONITOR from 'radar-js-analytic-sdk'
// console.log(RADAR_MONITOR,390)

export default function () {
    // RADAR_MONITOR.setAscAndAsc2('111','222');
    // RADAR_MONITOR.setThirdProps("mid","333");
    // RADAR_MONITOR.setFourthProps("m2","123456");
    RADAR_MONITOR.setProject('QH_4649_1024').getAutoTrack();
}